/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { Link } from 'react-router-dom';
import { IconBox, Tag, Tone } from '../console/ui';
import { ExternalIc } from '../console/icons';

export interface ServiceTileProps {
  to: string;
  icon: React.ReactNode;
  title: React.ReactNode;
  sub: React.ReactNode;
  tag?: { tone: Tone; label: React.ReactNode };
  external?: boolean;
}

const tileCls =
  'ps-card flex flex-col gap-2.5 p-[18px] min-h-[44px] text-ps-text hover:border-ps-accent-line hover:bg-ps-hover transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ps-accent';

/** Compact service tile used on Home ("Your services"). */
const ServiceTile: React.FC<ServiceTileProps> = ({ to, icon, title, sub, tag, external }) => {
  const body = (
    <>
      <div className="flex items-center justify-between gap-2">
        <IconBox className="[&>svg]:w-5 [&>svg]:h-5">{icon}</IconBox>
        {tag && <Tag tone={tag.tone}>{tag.label}</Tag>}
      </div>
      <div className="font-semibold flex items-center gap-1.5">
        {title}
        {external && <ExternalIc className="w-3.5 h-3.5 text-ps-subtle" aria-label="opens in a new tab" />}
      </div>
      <div className="text-[13px] text-ps-muted">{sub}</div>
    </>
  );
  return external ? (
    <a href={to} target="_blank" rel="noopener noreferrer" className={tileCls}>
      {body}
    </a>
  ) : (
    <Link to={to} className={tileCls}>
      {body}
    </Link>
  );
};

export default ServiceTile;
